// Shared colored-badge styling for Incident Category / Severity values, so
// every table (Incident Category Matrix, SOP List, Create Tasks list, ...)
// renders these the same way instead of plain text.

export const badgeBase = {
  display: "inline-block",
  padding: "2px 10px",
  borderRadius: "12px",
  fontSize: "11px",
  fontWeight: 600,
  whiteSpace: "nowrap",
  lineHeight: 1.6,
};

const CATEGORY_BADGE_PALETTE = [
  "#1d5fa8", // blue
  "#1e7e34", // green
  "#c2410c", // orange
  "#6b3fa0", // purple
  "#b02a4a", // rose
  "#0f766e", // teal
  "#a67c00", // gold
  "#475569", // slate
  "#0e7490", // cyan
  "#9d174d", // magenta
];

// Stable colours for common hazard types; anything else is hashed to a palette slot.
const KNOWN_CATEGORY_COLORS = {
  earthquake: 7,
  flood: 0,
  "flash flood": 0,
  "cloud burst": 5,
  cloudburst: 5,
  avalanche: 8,
  landslide: 2,
  cyclone: 3,
  storm: 3,
  fire: 4,
  wildfire: 4,
  drought: 6,
  "heat wave": 2,
  "cold wave": 8,
  tsunami: 1,
  "industrial hazard": 9,
};

const hashString = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
};

export const getCategoryBadgeStyle = (category) => {
  const key = (category || "").trim().toLowerCase();
  const idx = Object.prototype.hasOwnProperty.call(KNOWN_CATEGORY_COLORS, key)
    ? KNOWN_CATEGORY_COLORS[key] % CATEGORY_BADGE_PALETTE.length
    : hashString(key) % CATEGORY_BADGE_PALETTE.length;
  return {
    ...badgeBase,
    background: CATEGORY_BADGE_PALETTE[idx],
    color: "#fff",
    border: "1px solid transparent",
  };
};

export const getSeverityBadgeStyle = (severity) => {
  const s = (severity || "").toLowerCase();
  let palette = { background: "#eef2f7", color: "#5b6b7a", borderColor: "#d5e0ea" };
  if (s.includes("minor") || s.includes("level 1")) {
    palette = { background: "#e6f4ea", color: "#1e7e34", borderColor: "#b7e1c1" };
  } else if (s.includes("moderate") || s.includes("level 2")) {
    palette = { background: "#fff4e0", color: "#b26a00", borderColor: "#f2d9a8" };
  } else if (s.includes("major") || s.includes("level 3")) {
    palette = { background: "#ffe9d9", color: "#c2410c", borderColor: "#f3c2a0" };
  } else if (s.includes("critical") || s.includes("level 4")) {
    palette = { background: "#fde5e5", color: "#c0392b", borderColor: "#f2b8b8" };
  }
  return {
    ...badgeBase,
    background: palette.background,
    color: palette.color,
    border: `1px solid ${palette.borderColor}`,
  };
};
